export const removeDuplicates = (array: any[]) => {
  if (!array) return [];
  return array.reduce((acc, item) => {
    if (!acc.some((existingItem: any) => existingItem.value === item.value)) {
      acc.push(item);
    }
    return acc;
  }, []);
};
